import * as Cookies from 'es-cookie';
import { Profile } from 'types/auth';

/**
 * Get a cookie value by name
 */
export const getCookie = (name: string): string | undefined => Cookies.get(name);

/**
 * Get the auth token from cookies
 */
export const getAuthToken = (): string | null => getCookie('whoop-auth-token') || null;

/**
 * Get the auth user from cookies and parse as JSON
 */
export const getAuthUser = (): Profile | null => {
  const userCookie = getCookie('whoop-auth-user');
  if (!userCookie) {
    return null;
  }

  try {
    return JSON.parse(decodeURIComponent(userCookie)) as Profile;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Failed to parse auth user cookie:', error);
    return null;
  }
};

/**
 * Build the ID app URL with return URL parameter
 */
export const buildIdAppUrl = (returnUrl: string): string => {
  const idAppUrl = window._env?.ID_APP_URL || 'https://id.whoopunite.com';
  const encodedReturnUrl = encodeURIComponent(returnUrl);
  return `${idAppUrl}?for=${encodedReturnUrl}`;
};
